import React from "react";
import ConfigETC from "../Class/ConfigETC.json";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Pathurl from "../Class/Pathurl.json";import {
  Class_ETC_Encrypt,
} from "../Class/Class_Etc";
import { Link } from "react-router-dom";

/*

  Update By POOM : 2024-05-20
    - เพิ่ม link กดไปยังหน้า customer view


*/


function Customer_View({ list, index, Onclick_EditCustomer, Onclick_DeleteCustomer,permissionEdit,permissionDel}) {
    return (
  
        <TableRow>
            <TableCell width={"5%"}  align={"left"} ><div>{index}<input type="hidden" id="hd_iddel" defaultValue={list.cus_id}></input></div></TableCell>
            <TableCell width={"65%"} align={"left"} ><div>{list.cus_name}</div></TableCell>
            <TableCell width={"15%"} align={"center"} >
              <div>
                <span
                  className={
                    list.cus_status === 1
                      ? ConfigETC.Status_active
                      : ConfigETC.Status_inactive
                  }
                >
                  {list.cus_status_str}
                </span>
              </div>
            </TableCell>
            <TableCell width={"15%"} align={"right"}>
            <div className="btn-group btn-group-sm">

                <Link
                  to={"../" + Pathurl.m_customer_view}
                  state={{
                    cusid: Class_ETC_Encrypt(list.cus_id.toString()),
                    fromPage: Class_ETC_Encrypt(Pathurl.m_customer),
                  }}
                  data-toggle="tooltip"
                  title="Click for view detail"
                  className="btn bg-success btn-sm d-none"
                >
                  <i className="fas fa-tachometer-alt" />
                </Link>

               {(permissionEdit === true) &&
                <a
                  href="#!"
                  className="btn btn-primary btn-sm"
                  onClick={(event) => Onclick_EditCustomer(event, list)}
                > <i className="fas fa-pencil-alt" />
                </a>
               }
               {(permissionDel === true) &&
                <a
                  href="#!" className="btn btn-default btn-sm"
                  onClick={() => Onclick_DeleteCustomer(list.cus_id)}
                > <i className="fas fa-trash" />
                </a>
              }
                </div>
            </TableCell>
        </TableRow> 
    );
  };
  
  export default Customer_View;